export default __webpack_public_path__ + "static/farm_security_upgrade-0c3c5797b44318f55003142c231cd7ab.png";